<template>
    <el-card class="customer-info">
        <div class="mb-3">
            <el-tooltip
                class="margin: 4px"
                effect="dark"
                :content="$t('tooltip.back')"
                placement="bottom">
                <el-button
                    type="primary"
                    icon="iconfont icon-fitness-chehuisekuai"
                    circle
                    @click="goBack" />
            </el-tooltip>
            <span class="message ml-2">{{ message }}</span>
        </div>
        <div style="border-top:1px solid #ccc; margin: 20px 0 20px 0px;"></div>
        <el-tabs v-model="showActiveName" @tab-click="handleClick" type="border-card">
            <el-tab-pane :label="$t('Common.base_info')" name="first">
                <el-form
                    ref="form"
                    :model="form"
                    label-width="160px"
                    v-loading="loading"
                    label-suffix=":"
                    v-if="form">
                    <el-row type="flex" class="row-bg" justify="start">
                        <el-col :span="8">
                            <el-form-item
                                prop="name"
                                :label="$t('Common.name')">
                                {{ form.name }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item
                                :label="$t('Common.gender')"
                                prop="gender">
                                {{ form.gender }}
                            </el-form-item>
                        </el-col>
                        <!-- <el-form-item  prop="image" class="w-1/3" > -->
                        <img
                            :src="form.avatar"
                            height="64"
                            class="missing"
                            style="padding: 0 50px;">
                        <!-- </el-form-item> -->
                    </el-row>
                    <el-row type="flex" class="row-bg" justify="start">
                        <el-col :span="8">
                            <el-form-item
                                :label="$t('Common.telephone_number')"
                                prop="phone"
                            >{{ form.phone }}</el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item
                                :label="$t('Common.birthday')"
                            >{{ form.birthday }}</el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex" class="row-bg" justify="start">
                        <el-col :span="8">
                            <el-form-item :label="$t('Common.wechat')">{{ form.wechat }}</el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="Number(form.typeCode) === 2">
                            <el-form-item :label="$t('Contract.card_hao')">{{ form.cardNum }}</el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex" class="row-bg" justify="start" v-if="Number(form.typeCode) === 2">
                        <el-col :span="8">
                            <el-form-item :label="$t('Client.Add.referrer')"></el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('Client.phy_id')">{{ form.cardPhysicalId }}</el-form-item>
                        </el-col>
                    </el-row>
                    <div style="border-top:1px solid #ccc; margin: 20px 0 20px 0px;"></div>
                    <el-row type="flex" class="row-bg" justify="start">
                        <el-col :span="8">
                            <el-form-item
                                :label="$t('Common.distribution_saler')"
                                prop="mshpSalesNickname">
                                {{ form.mshpSalesNickname }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('Client.Add.follow_level')">
                                {{ form.followLevel }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex" class="row-bg" justify="start">
                        <el-col :span="8">
                            <el-form-item :label="$t('Client.Add.get_attributes')">
                                {{ form.channelSource }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('Client.Add.attributes')">
                                {{ form.channelAttr }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div style="border-top:1px solid #ccc; margin: 20px 0 20px 0px;"></div>
                    <el-row type="flex" class="row-bg" justify="start">
                        <el-col :span="8">
                            <el-form-item prop="certType" :label="$t('Client.Add.certificate_type')">
                                {{ form.certType }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item prop="certNum" :label="$t('Client.Add.certificate_number')">
                                {{ form.certNum }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex" class="row-bg" justify="start">
                        <el-col :span="8">
                            <el-form-item prop="citizenship" :label="$t('Client.Add.Country_of_Citizenship')">
                                {{ form.citizenship }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item prop="nation" :label="$t('Client.Add.nation')">
                                {{ form.nation }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex" class="row-bg" justify="start">
                        <el-col :span="8">
                            <el-form-item prop="email" label="E-mail">{{ form.email }}</el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item prop="homeAddress" :label="$t('Client.address')">
                                {{ form.homeAddress }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex" class="row-bg" justify="start">
                        <el-col :span="8">
                            <el-form-item prop="companyName" :label="$t('Client.Add.company_name')">
                                {{ form.companyName }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item prop="companyPhone" :label="$t('Client.Add.company_phone')">
                                {{ form.companyPhone }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex" class="row-bg" justify="start">
                        <el-col :span="8">
                            <el-form-item
                                prop="contactName"
                                :label="$t('Client.Add.emergency_contact')"
                            >{{ form.contactName }}</el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item
                                prop="contactPhone"
                                :label="$t('Client.Add.contact_people')"
                            >{{ form.contactPhone }}</el-form-item>
                        </el-col>
                    </el-row>
                    <div style="border-top:1px solid #ccc; margin: 20px 0 20px 0px;"></div>

                    <el-row type="flex" class="row-bg" justify="start">
                        <el-col :span="8">
                            <el-form-item prop="joinedClub" :label="$t('Client.Add.club')">
                                {{ form.joinedClub }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item prop="fitnessPurpose" :label="$t('Client.Add.purpose')">
                                {{ form.fitnessPurpose }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex" class="row-bg" justify="start">
                        <el-col :span="8">
                            <el-form-item
                                prop="wasFitnessMember"
                                :label="$t('Client.Add.member_is')">
                                {{ form.wasFitnessMember }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item
                                prop="leftReason"
                                :label="$t('Client.Add.leave_reason')"
                                v-if="form.wasFitnessMemberCode === 1"
                            >{{ form.leftReason }}</el-form-item>
                        </el-col>
                    </el-row>
                    <div style="border-top:1px solid #ccc; margin: 20px 0 20px 0px;"></div>
                    <el-row type="flex" class="row-bg" justify="start">
                        <el-col :span="8">
                            <el-form-item
                                prop="category"
                                :label="$t('Client.Add.customer_type')"
                            >{{ form.category }}</el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item
                                prop="infoHabit"
                                :label="$t('Client.Add.get_information_habits')"
                            >{{ form.infoHabit }}</el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex" class="row-bg" justify="start">
                        <el-col :span="8">
                            <el-form-item
                                prop="marriage"
                                :label="$t('Client.Add.marital_status')"
                            >{{ form.marriage }}</el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item
                                prop="children"
                                :label="$t('Client.Add.child_situation')"
                            >{{ form.children }}</el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item
                        prop="clientTagNames"
                        :label="$t('Client.Add.customer_label')"
                    >{{ form.clientTagNames }}</el-form-item>
                    <el-form-item prop="mshpAt" :label="$t('Member.Desc.time')">{{ form.mshpAt }}</el-form-item>
                    <el-form-item prop="mshpAt" :label="$t('Week.entry_time')">{{ form.createdAt }}</el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane :label="$t('Member.membership')" name="second">
                <el-table v-if="clientCard" :data="clientCard" class="my-4" v-loading="loading">
                    <el-table-column prop="contractNum" :label="$t('Contract.number')" align="center" width="100px"/>
                    <el-table-column prop="cardNum" :label="$t('Contract.card_hao')" align="center"/>
                    <el-table-column prop="storeName" :label="$t('Member.sign_store')" align="center"/>
                    <el-table-column prop="supportStoreNames" :label="$t('Reception.First.support_store')" align="center"/>
                    <el-table-column prop="cardName" :label="$t('Contract.card_name')" align="center"/>
                    <el-table-column prop="cardCredit" :label="$t('Contract.Desc.amount')" align="center" width="120"/>
                    <el-table-column prop="cardBalance" :label="$t('Contract.Desc.current_remaining')" align="center"/>
                    <el-table-column prop="type" :label="$t('Contract.type')" align="center"/>
                    <el-table-column prop="originalContractNum" :label="$t('Contract.Desc.old_number')" align="center"/>
                    <el-table-column prop="status" :label="$t('Contract.status')" align="center"/>
                    <el-table-column prop="createdAt" :label="$t('Sell.sign_date')" align="center"/>
                    <el-table-column prop="activeCardWay" :label="$t('Member.open_card_method')" align="center"/>
                    <el-table-column prop="startAt" :label="$t('Contract.start_time')" align="center"/>
                    <el-table-column prop="endAt" :label="$t('Contract.end_time')" align="center"/>
                    <el-table-column prop="contractSalesStaffNickname" :label="$t('Member.saler')" align="center"/>
                    <el-table-column prop="recommendClientName" :label="$t('Client.Add.referrer')" align="center"/>
                    <el-table-column prop="editorStaffNickname" :label="$t('Member.Desc.entry')" align="center"/>
                </el-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('Course.personal_lesson')" name="third">
                <el-table :data="coachLesson" class="my-4" v-loading="loading">
                    <el-table-column prop="contractNum" :label="$t('Contract.number')" align="center" width="100px"/>
                    <el-table-column prop="cardNum" :label="$t('Contract.card_hao')" align="center"/>
                    <el-table-column prop="lessonName" :label="$t('Lesson.lesson.classGrade')" align="center"/>
                    <el-table-column prop="lessonCredit" :label="$t('Member.buy_count')" align="center"/>
                    <el-table-column prop="lessonBalance" :label="$t('Lesson.lesson.residueClass')" align="center"/>
                    <el-table-column prop="type" :label="$t('Contract.type')" align="center"/>
                    <el-table-column prop="originalContractNum" :label="$t('Contract.Desc.old_number')" align="center"/>
                    <el-table-column prop="status" :label="$t('Contract.status')" align="center"/>
                    <el-table-column prop="createdAt" :label="$t('Sell.sign_date')" align="center"/>
                    <el-table-column prop="startAt" :label="$t('Contract.start_time')" align="center"/>
                    <el-table-column prop="endAt" :label="$t('Contract.end_time')" align="center"/>
                    <el-table-column prop="contractSalesStaffNickname" :label="$t('Member.saler')" align="center"/>
                    <el-table-column prop="editorStaffNickname" :label="$t('Member.Desc.entry')" align="center"/>
                </el-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('Common.locker')" name="forth">
                <el-table :data="lockers" class="my-4" v-loading="loading">
                    <el-table-column prop="contractNum" :label="$t('Contract.number')" align="center" width="100px"/>
                    <el-table-column prop="cardNum" :label="$t('Contract.card_hao')" align="center"/>
                    <el-table-column prop="lockerCode" :label="$t('Common.cabinet_number')" align="center"/>
                    <el-table-column prop="lease" :label="$t('Week.lease_period2')" align="center"/>
                    <el-table-column prop="type" :label="$t('Contract.type')" align="center"/>
                    <el-table-column prop="originalContractNum" :label="$t('Contract.Desc.old_number')" align="center"/>
                    <el-table-column prop="status" :label="$t('Contract.status')" align="center"/>
                    <el-table-column prop="createdAt" :label="$t('Sell.sign_date')" align="center"/>
                    <el-table-column prop="startAt" :label="$t('Contract.start_time')" align="center"/>
                    <el-table-column prop="endAt" :label="$t('Contract.end_time')" align="center"/>
                    <el-table-column prop="contractSalesStaffNickname" :label="$t('Member.saler')" align="center"/>
                    <el-table-column prop="editorStaffNickname" :label="$t('Member.Desc.entry')" align="center"/>
                </el-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('Card.card1')" name="fifth">
                <el-table v-if="czCard" :data="czCard" class="my-4" v-loading="loading">
                    <el-table-column prop="contractNum" :label="$t('Contract.number')" align="center" width="100px"/>
                    <el-table-column prop="cardNum" :label="$t('Contract.card_hao')" align="center"/>
                    <el-table-column prop="cardName" :label="$t('Card.cardName')" align="center"/>
                    <!-- <el-table-column prop="cardId" label="储值卡ID" align="center"/> -->
                    <el-table-column prop="cardCredit" :label="$t('Card.cardRecharge')" align="center"/>
                    <el-table-column prop="cardBalance" :label="$t('Contract.Desc.current_remaining')" align="center"/>
                    <el-table-column prop="type" :label="$t('Contract.type')" align="center"/>
                    <el-table-column prop="originalContractNum" :label="$t('Contract.Desc.old_number')" align="center"/>
                    <el-table-column prop="status" :label="$t('Contract.status')" align="center"/>
                    <el-table-column prop="createdAt" :label="$t('Sell.sign_date')" align="center"/>
                    <el-table-column prop="startAt" :label="$t('Contract.start_time')" align="center"/>
                    <el-table-column prop="endAt" :label="$t('Contract.end_time')" align="center"/>
                    <el-table-column prop="contractSalesStaffNickname" :label="$t('Member.saler')" align="center"/>
                    <el-table-column prop="editorStaffNickname" :label="$t('Member.Desc.entry')" align="center"/>
                </el-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('Reception.First.sign')" name="sixth">
                <el-table v-if="enterData" :data="enterData" class="my-4" v-loading="loading">
                    <el-table-column prop="index" :label="$t('Contract.Desc.number')" align="center"/>
                    <el-table-column prop="teamLessonName" :label="$t('Common.enter_store')" align="center"/>
                    <el-table-column prop="teamLessonTime" :label="$t('Reception.Sixth.has_card')" align="center"/>
                    <el-table-column prop="reserveWay" :label="$t('Reception.Sixth.kou')" align="center"/>
                    <el-table-column prop="status" :label="$t('Common.enter_time')" align="center"/>
                    <el-table-column prop="createdAt" :label="$t('Common.outer_time')" align="center"/>
                    <el-table-column prop="createdAt" :label="$t('Reception.First.temporary_locker')" align="center"/>
                </el-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('Lesson.lesson.organizationClass')" name="seventh">
                <el-table v-if="teamSchedule" :data="teamSchedule" class="my-4" v-loading="loading">
                    <el-table-column prop="index" :label="$t('Contract.Desc.number')" align="center"/>
                    <el-table-column prop="teamLessonName" :label="$t('Course.name2')" align="center"/>
                    <el-table-column prop="teamLessonTime" :label="$t('Course.time')" align="center"/>
                    <el-table-column prop="reserveWay" :label="$t('Contract.Desc.subscribeWay')" align="center"/>
                    <el-table-column prop="status" :label="$t('Course.appoint_status')" align="center"/>
                    <el-table-column prop="createdAt" :label="$t('Reception.Second.appoint_time')" align="center"/>
                </el-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('Board.Personal.title')" name="eighth">
                <el-table
                    v-if="showActiveName === 'eighth'"
                    :data="coachSchedule"
                    class="my-4"
                    v-loading="loading">
                    <el-table-column prop="index" :label="$t('Contract.Desc.number')" align="center"/>
                    <el-table-column prop="coachLessonName" :label="$t('Lesson.lesson.Name_of_Private_class')" align="center"/>
                    <el-table-column prop="coachLessonTime" :label="$t('Course.time')" align="center"/>
                    <el-table-column prop="actualCoachId" :label="$t('Course.coach')" align="center"/>
                    <el-table-column prop="actualCoachNickname" :label="$t('Lesson.lesson.Class_coach_name')" align="center"/>
                    <el-table-column prop="lessonBalance" :label="$t('Lesson.lesson.residue_class')" align="center"/>
                </el-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('Lesson.lesson.integration')" name="nine">
                <el-table v-if="pointRecord" :data="pointRecord" class="my-4" v-loading="loading">
                    <el-table-column prop="id" :label="$t('Lesson.lesson.integration_recordID')" align="center" width="100px"/>
                    <el-table-column prop="point" :label="$t('Lesson.lesson.integrationNumber')" align="center"/>
                    <el-table-column prop="balance" :label="$t('Card.amt')" align="center"/>
                    <el-table-column prop="remark" :label="$t('Common.remark')" align="center"/>
                    <el-table-column prop="createdAt" :label="$t('Reception.Third.time')" align="center" width="120"/>
                </el-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('Member.Follow.sms')" name="ten">
                <el-table v-if="smsRecord" :data="smsRecord" class="my-4" v-loading="loading">
                    <el-table-column prop="id" :label="$t('Member.Follow.sms_id')" align="center" width="100px"/>
                    <el-table-column prop="createdAt" :label="$t('Member.Follow.send_time')" align="center"/>
                    <el-table-column prop="content" :label="$t('Member.Follow.send_content')" align="center"/>
                    <el-table-column prop="operatorNickname" :label="$t('Member.Follow.operat_staff')" align="center"/>
                    <el-table-column prop="operatorId" :label="$t('Member.Follow.operat_staff_id')" align="center" width="120"/>
                </el-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('Member.Follow.record')" name="eleven">
                <el-table v-if="assignRecord" :data="assignRecord" class="my-4" v-loading="loading">
                    <el-table-column prop="id" :label="$t('Member.Follow.record_id')" align="center" width="100px"/>
                    <el-table-column prop="preMshpSalesNickname" :label="$t('Member.Distribution.saler')" align="center"/>
                    <el-table-column prop="aftMshpSalesNickname" :label="$t('Member.Distribution.saler_after')" align="center"/>
                    <el-table-column prop="aftCoachNickname" :label="$t('Member.Distribution.coach')" align="center"/>
                    <el-table-column prop="preCoachNickname" :label="$t('Member.Distribution.coach_after')" align="center" width="120"/>
                    <el-table-column prop="assignStaffNickname" :label="$t('Member.Distribution.staff')" align="center" width="120"/>
                    <el-table-column prop="createdAt" :label="$t('Member.Distribution.time')" align="center" width="120"/>
                </el-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('Common.followup_record')" name="twelve">
                <el-table v-if="followRecord" :data="followRecord" class="my-4" v-loading="loading">
                    <el-table-column prop="id" :label="$t('Member.Follow.id')" align="center" width="100px"/>
                    <el-table-column prop="recordType" :label="$t('Member.Follow.record_type')" align="center"/>
                    <el-table-column prop="remark" :label="$t('Member.Follow.record_remark')" align="center"/>
                    <el-table-column prop="followStaffId" :label="$t('Member.Follow.record_staff')" align="center"/>
                    <el-table-column prop="followStaffNickname" :label="$t('Member.Follow.record_staff_name')" align="center"/>
                    <el-table-column prop="createdAt" :label="$t('Member.Follow.time')" align="center" width="120"/>
                </el-table>
            </el-tab-pane>
            <!-- 分页 -->
            <el-pagination
                v-if="showPage"
                class="text-right"
                @current-change="fetchData"
                :current-page.sync="pagination.page"
                :page-size="pagination.size"
                layout="total, prev, pager, next, jumper"
                :total="pagination.total"
            ></el-pagination>
        </el-tabs>
    </el-card>
</template>

<script>
import {
    Row,
    Col,
    Tooltip,
    Table,
    TableColumn,
    Pagination,
    Tabs,
    TabPane,
    Dialog,
} from 'element-ui';

export default {
    name: 'show-details',
    components: {
        ElRow: Row,
        ElCol: Col,
        Tooltip: Tooltip,
        ElTable: Table,
        ElTableColumn: TableColumn,
        ElPagination: Pagination,
        ElTabs: Tabs,
        ElTabPane: TabPane,
        ElDialog: Dialog,
    },
    data() {
        return {
            message: '',
            showPage: false,
            id: '',
            activeName: null,
            showActiveName: 'first',
            loading: false,
            form: null,
            clientCard: [],
            pointRecord: [],
            smsRecord: [],
            assignRecord: [],
            followRecord: [],
            coachLesson: [],
            teamSchedule: [],
            coachSchedule: [],
            enterData: [],
            lockers: [],
            czCard: [],
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
        };
    },
    created() {
        if (this.$route.params.activeName) this.activeName = this.$route.params.activeName;
        if (this.$route.params.id) this.fetchData();
    },
    methods: {
        getCreatAtTime(date) {
            const dateBegin = new Date(date);
            const dateEnd = new Date();
            const dateDiff = dateEnd.getTime() - dateBegin.getTime();
            // 计算出相差天数
            const dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));
            const leave1 = dateDiff % (24 * 3600 * 1000);
            const hours = Math.floor(leave1 / (3600 * 1000));
            // 计算相差分钟数
            const leave2 = leave1 % (3600 * 1000);
            const minutes = Math.floor(leave2 / (60 * 1000));
            // 计算相差秒数
            const leave3 = leave2 % (60 * 1000);
            const seconds = Math.round(leave3 / 1000);
            if (dayDiff) return `${dayDiff}天`;
            else if (hours) return `${hours}小时`;
            else if (minutes) return `${minutes}${$t('Common.minute')}`;
            return `${seconds}秒`;
        },
        fetchData() {
            this.loading = true;
            API.get(`client/${this.$route.params.id}`)
            .then(res => {
                this.form = res;
                const dateDiff = this.getCreatAtTime(res.createdAt);
                this.message = `客户信息- ${res.name} ${res.gender}(${res.type} | ${dateDiff}前录入系统）`;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        handleClick() {
            switch (this.showActiveName) {
            case 'first':
                this.showPage = false;
                this.fetchData();
                break;
            case 'second':
                this.showPage = false;
                this.fetchClientCard();
                break;
            case 'third':
                this.showPage = false;
                this.fetchCoachLesson();
                break;
            case 'forth':
                this.showPage = false;
                this.fetchLocker();
                break;
            case 'fifth':
                this.showPage = false;
                this.fetchCzCard();
                break;
            case 'sixth':
                this.showPage = true;
                this.fetchEnter();
                break;
            case 'seventh':
                this.showPage = false;
                this.fetchTeamSchedule();
                break;
            case 'eighth':
                this.showPage = false;
                this.fetchCoachSchedule();
                break;
            case 'nine':
                this.showPage = true;
                this.fetchPointRecord();
                break;
            case 'ten':
                this.showPage = true;
                this.fetchSmsRecord();
                break;
            case 'eleven':
                this.showPage = true;
                this.fetchAssignRecord();
                break;
            case 'twelve':
                this.showPage = true;
                this.fetchFollowRecord();
                break;
            default:
                break;
            }
        },
        fetchClientCard(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get(`client/${this.$route.params.id}/contract-mshp`, {
                params: { ...this.pagination },
            })
            .then(res => {
                this.clientCard = res;
                this.pagination.total = res.totalElements;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchPointRecord(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get(`client/${this.$route.params.id}/point-record`, {
                params: { ...this.pagination },
            })
            .then(res => {
                this.pointRecord = res.content;
                this.pagination.total = res.totalElements;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchSmsRecord(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get(`client/${this.$route.params.id}/sms-record`, {
                params: { ...this.pagination },
            })
            .then(res => {
                this.smsRecord = res.content;
                this.pagination.total = res.totalElements;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchAssignRecord(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get(`client/${this.$route.params.id}/assign-record`, {
                params: { ...this.pagination },
            })
            .then(res => {
                this.assignRecord = res.content;
                this.pagination.total = res.totalElements;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchFollowRecord(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get(`client/${this.$route.params.id}/follow-record`, {
                params: { ...this.pagination },
            })
            .then(res => {
                this.followRecord = res.content;
                this.pagination.total = res.totalElements;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchCoachLesson(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get(`client/${this.$route.params.id}/contract-coach`, {
                params: { ...this.pagination },
            })
            .then(res => {
                this.coachLesson = res;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchLocker(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get(`client/${this.$route.params.id}/contract-locker`, {
                params: { ...this.pagination },
            })
            .then(res => {
                this.lockers = res;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchCzCard(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get(`client/${this.$route.params.id}/contract-cz-card`, {
                params: { ...this.pagination },
            })
            .then(res => {
                this.czCard = res;
                this.pagination.total = res.totalElements;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchTeamSchedule() {
            this.loading = true;
            API.get(`client/${this.$route.params.id}/team-schedule`)
            .then(res => {
                this.teamSchedule = res;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchEnter() {
            this.loading = true;
            API.get(`client/${this.$route.params.id}/entrance-record`)
            .then(res => {
                this.enterData = res.content;
                this.pagination.total = res.totalElements;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchCoachSchedule() {
            this.loading = true;
            API.get(`client/${this.$route.params.id}/coach-schedule`)
            .then(res => {
                this.coachSchedule = res;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        showImg(item) {
            this.img = item;
            this.isShowImg = true;
            this.index = this.form.albums.findIndex(el => el === item);
        },
        goBack() {
            this.$router.back();
        },
    },
};
</script>
<style lang="scss">
.customer-info {
    font-size: 14px;
}
</style>
